import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import Card, { CardHeader } from '../components/ui/Card';
import Button from '../components/ui/Button';
import EntityTable from '../components/shared/EntityTable';
import EntityModal from '../components/modals/EntityModal';
import { useAppStore } from '../store';
import { Client } from '../types';

const Clients: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const { clients, addClient, currentUser } = useAppStore();
  
  // Filtrado por vendedor solo en esta pantalla
  let filteredClients = clients.filter(client => 
    client.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (client.email && client.email.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  // Solo filtrar si el usuario es vendedor
  const userRole = currentUser?.role ? currentUser.role.trim().toLowerCase() : '';
  if (userRole === 'vendedor') {
    let vendedor = null;
    if (currentUser.email && currentUser.email.trim().toLowerCase() === 'malena@productex.com.ar') vendedor = 'male';
    if (currentUser.email && currentUser.email.trim().toLowerCase() === 'mateo@productex.com.ar') vendedor = 'mateo';
    if (vendedor) {
      filteredClients = filteredClients.filter(client => (client.salesperson || '').trim().toLowerCase() === vendedor);
    }
  }
  
  const handleAddClient = () => {
    setIsModalOpen(true);
  };
  
  const handleSaveClient = async (newClient: Omit<Client, 'id' | 'balance'>) => {
    await addClient(newClient);
    setIsModalOpen(false);
  };
  
  const handleViewDetails = (id: string) => {
    // This function is handled in EntityTable
  };
  
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between gap-4">
        <div className="relative">
          <input
            type="text"
            placeholder="Buscar clientes..."
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
        
        <Button 
          variant="primary" 
          icon={<Plus className="h-5 w-5" />}
          onClick={handleAddClient}
        >
          Nuevo Cliente
        </Button>
      </div>
      
      <Card>
        <CardHeader title={`Clientes (${filteredClients.length})`} />
        
        <EntityTable
          data={filteredClients}
          entityType="client"
          onViewDetails={handleViewDetails}
        />
      </Card>

      <EntityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        entityType="client"
        onSave={handleSaveClient}
      />
    </div>
  );
};

export default Clients;